import type { VideoAssetDto } from "../api/videoService";

/**
 * 0925 通道亮账:通道码 → 小标文字。ark 按品牌写大写 ARK,其余原样(vapeur 本就小写品牌名;
 * 没见过的新通道也原样透出,不猜)。
 */
export function channelName(ch: string): string {
  return ch.toLowerCase() === "ark" ? "ARK" : ch;
}

/** 段卡片通道小标:无 channelUsed → null(不显示);failover 过 → 「原主通道→实际通道」。 */
export function channelTag(c: Pick<VideoAssetDto, "channelUsed" | "failoverFrom">): string | null {
  if (!c.channelUsed) return null;
  return c.failoverFrom
    ? `${channelName(c.failoverFrom)}→${channelName(c.channelUsed)}`
    : channelName(c.channelUsed);
}
